import { render, staticRenderFns } from "./TermVetScanner.vue?vue&type=template&id=0d97bd6f&scoped=true"
import script from "./TermVetScanner.vue?vue&type=script&lang=js"
export * from "./TermVetScanner.vue?vue&type=script&lang=js"
import style0 from "./TermVetScanner.vue?vue&type=style&index=0&id=0d97bd6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97bd6f",
  null
  
)

export default component.exports